import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerScroll = styled.div`
  position: relative;
  width: 100%;
`;

export const ContainerButtonArrow = styled.div<{
  $position: 'direita' | 'esquerda';
}>`
  position: absolute;
  ${({ $position }) =>
    $position === 'esquerda' ? 'left: -20px;' : 'right: -16px;'}
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`;
